<template>
  <div class="step-progress-bar">
    <!-- 步骤条 -->
    <div class="step-bar">
      <div
        v-for="(step, index) in steps"
        :key="index"
        :class="{ active: index === defaultStep, 'step-item': true }"
        @click="stepChange(index)"
      >
        <span class="step-num">{{ index + 1 }}</span>{{ step }}
        <div
          v-if="index + 1 !== steps.length"
          class="arrow-box"
        >
        </div>
        <div
          v-if="index + 1 !== steps.length"
          class="arrow-border"
        >
        </div>
      </div>
    </div>
    <!-- 中间部分（可滚动） -->
    <div class="scrollable-content">
      <slot :default-step="defaultStep"></slot>
    </div>
    <!-- 按钮区域 -->
    <div class="button-area">
      <el-button
        :disabled="defaultStep === 0"
        @click="prevStep"
      >
        {{ upStepName }}
      </el-button>
      <el-button
        v-if="defaultStep !== steps.length - 1"
        type="primary"
        @click="defaultNextStep"
      >
        {{ downStepName }}
      </el-button>
      <el-button
        v-else
        type="primary"
        @click="submit"
      >
        {{ submitStepName }}
      </el-button>
      <slot name="button"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue';

  const props = defineProps({
    steps: {
      type: Array,
      required: true,
    },
    defaultStep: {
      type: Number,
      default: 0,
    },
    upStepName: {
      type: String,
      default: '上一步',
    },
    downStepName: {
      type: String,
      default: '下一步',
    },
    submitStepName: {
      type: String,
      default: '提交',
    },
    checkInput: {
      type: Boolean,
      default: false,
    },
  });
  const emitEvents = defineEmits(['submitMethod', 'downStepMethod', 'changeStepMethods']);
  const defaultStep = ref(props.defaultStep);

  // 点击步骤时，更新当前步骤
  const stepChange = (index: number) => {
    defaultStep.value = index;
  };
  // 上一步
  const prevStep = () => {
    if (defaultStep.value > 0) {
      emitEvents('changeStepMethods', defaultStep.value, JSON.parse(JSON.stringify(defaultStep.value)) - 1);
      defaultStep.value--;
    }
  };
  // 暴露的下一步方法
  const nextStep = () => {
    if (defaultStep.value < props.steps.length - 1) {
      emitEvents('changeStepMethods', defaultStep.value, JSON.parse(JSON.stringify(defaultStep.value)) + 1);
      defaultStep.value++;
    }
  };
  // 下一步
  const defaultNextStep = () => {
    if (props.checkInput) {
      emitEvents('downStepMethod');
      return;
    }
    nextStep();
  };
  // 提交方法暴露给父组件提交按钮方法
  const submit = () => {
    emitEvents('submitMethod');
  };
  defineExpose({ nextStep });
</script>

<style scoped lang="scss">
.step-progress-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.step-bar {
  display: flex;
  width: 100%;
  height: 36px;
  border: 1px solid #EAEDF6;
  cursor: pointer;

  .step-item {
    position: relative;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    color: #434C59;
    font-weight: 500;
    text-align: center;
    background-color: #FAFBFE;

    .arrow-box {
      position: absolute;
      top: 0;
      right: -18px;
      z-index: 1;
      width: 0;
      height: 0;
      border-color: transparent transparent transparent #EAEDF6;
      border-style: solid;
      border-width: 18px 0 18px 20px;
    }

    .arrow-border {
      position: absolute;
      top: 0;
      right: -16px;
      z-index: 2;
      width: 0;
      height: 0;
      border-color: transparent transparent transparent #FAFBFE;
      border-style: solid;
      border-width: 18px 0 18px 20px;
    }

    .step-num {
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      width: 24px;
      height: 24px;
      margin-right: 6px;
      font-size: 14px;
      border: 2px solid #EAEDF6;
      border-radius: 50%;
    }
  }

  .active {
    color: #007AF5;
    font-weight: 700;
    background-color: #FFF;

    .arrow-border {
      position: absolute;
      top: 0;
      right: -16px;
      z-index: 9;
      width: 0;
      height: 0;
      border-color: transparent transparent transparent #FFF;
      border-style: solid;
      border-width: 18px 0 18px 20px;
    }

    .step-num {
      color: #FFF;
      background-color: #007AF5;
      border: 2px solid #007AF5;
    }
  }
}

.scrollable-content {
  width: 100%;
  height: calc(100% - 130px);
  padding: 20px;
  overflow-y: auto;
}

.button-area {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 59px;
  background-color: #FFF;
}
</style>
